/* eslint-disable react/style-prop-object */
import React, { useContext, useState, useMemo } from "react";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import { useGetSubmittalsEnumsQuery } from "../../../Redux/service/Submittals/Submittals";
import { useGetPOIProjectsQuery } from "../../../Redux/service/POIS/POIs";

export default function SubmittalsHead({ setFilter }) {
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const { data } = useGetSubmittalsEnumsQuery();
	const { data: projects } = useGetPOIProjectsQuery();
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const { typeOptions, disciplineOptions, statusOptions } = useMemo(() => {
		if (!data?.data)
			return { typeOptions: [], disciplineOptions: [], statusOptions: [] };

		const { SubmittalType, SubmittalDiscipline, SubmittalStatus } = data.data;
		const convertToOptions = (obj) =>
			Object.entries(obj).map(([key, value]) => ({
				label: trans(value),
				value: key,
			}));

		return {
			typeOptions: convertToOptions(SubmittalType),
			disciplineOptions: convertToOptions(SubmittalDiscipline),
			statusOptions: convertToOptions(SubmittalStatus),
		};
	}, [data]);

	return (
		<div className="bg-white p-16 d-flex align-items-baseline gap-3 flex-wrap">
			<Searchbar
				style="search search-dark input-group"
				path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
				placeholder={trans("Search")}
				value={query}
				onChange={handleSearch}
			/>

			<InputSelect
				placeholder={trans("Type")}
				options={typeOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, type: e }))}
			/>

			<InputSelect
				placeholder={trans("Discipline")}
				options={disciplineOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, discipline: e }))}
			/>

			<InputSelect
				placeholder={trans("Status")}
				options={statusOptions}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, status: e }))}
			/>
			<InputSelect
				placeholder={trans("Project")}
				options={projects?.data?.map((i) => {
					return { label: i.name, value: i.id };
				})}
				formstyle="flex-grow-1 text-capitalize"
				onChange={(e) => setFilter((prev) => ({ ...prev, projectId: e }))}
			/>
		</div>
	);
}
